function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "user--check");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z",
  transform: "translate(0 0)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z",
  transform: "translate(0 0)"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "25 16.18 22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle_",
  "data-name": "<Transparent Rectangle>",
  className: "cls-1",
  width: 32,
  height: 32
});

var SvgUserCheck = function SvgUserCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user--check.5bbf7990.svg";
export { ForwardRef as ReactComponent };